import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

API.interceptors.response.use(
  (res) => res,
  async (err) => {
    const orig = err.config || {};
    if (err.response?.status === 401 && !orig._retried && !String(orig.url || "").includes("/auth/")) {
      orig._retried = true;
      try {
        await API.post("/auth/refresh");
        return API(orig);
      } catch (e) {
        /* fall through */
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "কিছু একটা সমস্যা হয়েছে, আবার চেষ্টা করুন।";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(", ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default API;
